<template>
  <div class="disposables_edit">
    <!-- <span>{{$route.params.id}}</span> -->
    <div class="search-line">
        <div class="left">
            <!-- <h3>{{`${$route.params.id === '0' ? '新建' : '编辑'}耗材信息`}}</h3> -->
            <h3>{{`${$route.params.id === '0' ? `新建` : `编辑`}耗材`}}</h3>
        </div>
        <!-- <div class="right">
            <el-button type="primary" plain size="mini" @click.prevent="back"><i class="el-icon-back"></i>返回上一页</el-button>
        </div> -->
    </div>
    <div class="disposables_center mt10">
        <el-tabs v-model="activeName">
            <!-- 耗材基本信息 -->
            <el-tab-pane :label="`基本信息`" name="first">
                <el-form :model="form" :rules="rules" ref="form" label-width="120px">
                    <div class="divBorder">
                        <el-row>
                            <el-col :span="4">
                                <!-- 名称 -->
                                <el-form-item :label="`名称`" prop="name" >
                                    <el-input :placeholder="`请输入`" v-model="form.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 品牌 -->
                                <el-form-item :label="`品牌`" prop="">
                                    <el-input :placeholder="`请输入`" v-model="form.brand"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 类型 -->
                                <el-form-item :label="`类型`" prop="">
                                    <el-select v-model="form.instrument_type" clearable filterable placeholder="请选择耗材类型">
                                        <el-option
                                            v-for="item in sorts"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 规格 -->
                                <el-form-item :label="`规格`" prop="">
                                    <el-input :placeholder="`请输入`" v-model="form.specification"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 拼音码 -->
                                <el-form-item :label="`拼音`" prop="">
                                    <el-input :placeholder="`请输入`" v-model="form.abc_code"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="4">
                                <!-- 编号 -->
                                <el-form-item :label="`编号`" prop="" >
                                    <el-input :placeholder="`请输入`" v-model="form.code"></el-input>
                                </el-form-item>
                            </el-col>
                            <!-- 耗材厂家 -->
                            <el-col :span="4">
                                <!-- 生产厂家 -->
                                <el-form-item :label="`生产厂家`" prop="">
                                    <el-select
                                        v-model="form.produce_vendor_id"
                                        filterable
                                        clearable
                                        remote
                                        :placeholder="`请选择`"
                                        :remote-method="searchVendors"
                                        @focus="searchVendors('')"
                                    >
                                        <el-option
                                            v-for="item in produceOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- 服务类厂商 -->
                            <!-- 经销厂家 -->
                            <el-col :span="4">
                                <el-form-item :label="`经销厂家`" prop="">
                                    <el-select
                                        v-model="form.sale_vendor_id"
                                        filterable
                                        clearable
                                        remote
                                        :placeholder="`请选择`"
                                        :remote-method="searchSale"
                                        @focus="searchSale('')"
                                    >
                                        <el-option
                                            v-for="item in saleOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 成本金额 -->
                                <el-form-item :label="`成本金额`" prop="">
                                    <el-input-number class="input150" :placeholder="`请输入`" v-model="form.cost" controls-position="right" :min="0"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <!-- 预警数量 -->
                                <el-form-item :label="`预警数量`" prop="" >
                                    <el-input-number class="input150" :placeholder="`请输入`" v-model="form.alert_number" controls-position="right" :min="0"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="4">
                                <!-- 基本单位 -->
                                <el-form-item :label="`基本单位`" prop="">
                                    <el-input :placeholder="`请输入`" v-model="form.unit"></el-input>
                                    <!-- 添加单位换算 -->
                                    <el-button size="mini" type="primary" class="mt5" @click.prevent="addunitAll" icon="el-icon-plus" v-if="unitArr == false">添加</el-button>
                                    <!-- 取消单位换算 -->
                                    <el-button size="mini" type="primary" class="mt5" @click.prevent="deleteunitAll" icon="el-icon-minus" v-if="unitArr == true">取消</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <!-- 单位换算 -->
                                <el-form-item :label="`单位换算`" prop="" v-if="unitArr == true">
                                    <el-form-item
                                        class="mt5"
                                        v-for="(domain, index) in domains"
                                        :key="domain.key"
                                        >
                                        <span v-if="index >= 1"> = </span>
                                        <el-input :placeholder="`请输入`" class="input150" v-model="domain.number"></el-input>
                                        <el-input :placeholder="`请输入`" :disabled="index < 1" class="input150 ml5" v-model="domain.unit"></el-input>
                                        <!-- 删除 -->
                                        <el-button v-if="index >= 1" size="mini" type="warning" icon="el-icon-delete" class="mt5 ml5" @click.prevent="removeDomain(domain)">删除</el-button>
                                    </el-form-item>
                                    <!-- 新增 -->
                                    <el-button class="ml5" size="mini" icon="el-icon-plus" type="primary" @click="addDomain">新增</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="divBorder mt10">
                        <el-row>
                          <!-- 上传耗材照片 -->
                            <el-form-item :label="`照片`" prop="">
                              <!-- 上传照片 -->
                                <el-button class="input150" icon="el-icon-camera" size="mini" type="primary" @click="uploadAvatar()">上传</el-button>
                            </el-form-item>
                        </el-row>
                        <div class="upload-photo">
                            <li v-for="(item,index) in images" :key="index" >
                                <!-- <img style="height:150px;margin:0 0 20px 20px;" :src="item.url" alt=""/> -->
                                <el-image style="height:60px;margin:0 20px 20px 0;" :src="item.url" :preview-src-list="images.map(i => i.url)" />
                                <div ref="imgDelete" class="delete-img">
                                    <i class="el-icon-delete" @click="deleteimg(item.id)"></i>
                                </div>
                            </li>
                        </div>
                    </div>
                </el-form>
            </el-tab-pane>
            <!-- 附件 -->
            <el-tab-pane :label="`附件`" name="second">
              <!-- 上传文件 -->
                <el-button class="input110" icon="el-icon-upload2" @click="openUpload('file')" size="mini" type="primary">上传</el-button>
                <el-table
                    class="mt10"
                    stripe
                    border
                    v-loading="loading"
                    :data="form.file_list"  
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="#"
                        align="center"
                        width="60">
                    </el-table-column>
                    <!-- 文件名 -->
                    <el-table-column
                        prop="name"
                        :label="`文件名`"
                        align="center">
                    </el-table-column>
                    <!-- 文件类型 -->
                    <el-table-column
                        prop=""
                        :label="`类型`"
                        align="center">
                        <template slot-scope="scope">
                            {{fileTypes.filter(i => i.value === scope.row.type)[0].name}}
                        </template>
                    </el-table-column>
                    <!-- 操作 -->
                    <el-table-column
                        prop="address"
                        align="center"
                        :label="`操作`">
                        <template slot-scope="scope">
                        <el-button class="p0 fontsize20" type="text" @click.prevent="view(scope.row.url)"><i class="el-icon-download"></i></el-button>
                        <el-button class="p0 fontsize20" type="text" @click.prevent="deleteFile(scope.$index)"><i class="el-icon-delete"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <div class="mt10">
          <!-- 保存 -->
            <el-button size="small" type="primary" :loading="buttonLoading" @click="submitDisposables">保存</el-button>
            <!-- 取消 -->
            <el-button size="small" @click="back">取消</el-button>
        </div>
    </div>
    <PictureSelect ref="pictureSelect" @complete="getAvatar" />
    <UploadFile ref="uploadFile" @complete="getFile" />
  </div>
</template>

<script>
import PictureSelect from '@/components/common/PictureSelect/index.vue'
import UploadFile from '@/components/common/UploadFile.vue'
import { vendorOptions, disposablesList, disposablesEdit } from '@/api.js' 
export default {
    name:'disposablesEdit',
    components: {
        PictureSelect,UploadFile
    },
    data() {
        return {
            activeName: 'first',
            form:{
                image: [],
                file_list:[],
            },
            images:[],
            fileList:[],
            loading:false,
            //上传照片
            show:false,
            typeOptions:[],
            vendorsOptions:[],
            produceOptions:[],
            saleOptions:[],
            sorts:[],
            buttonLoading:false,
            unitArr:false,
            domains: [],
            // 表单校验
            rules: {
                name:[
                // 耗材名称不能为空
                    { required: true, message: `耗材名称不能为空`, trigger: "blur" }
                ],
            },
            fileTypes: [],
        }
    },
    created() {
        this.searchTypeOption();
        this.searchVendors();
        this.pageId = Number(this.$route.params.id)
        if (this.pageId) {
            this.getDetail(this.pageId)
        }
    },
    methods: {
        async getDetail(id) {
            // 获取耗材详情
            const url = disposablesEdit.replace('{id}', id)
            const res = await this.$request('get', url, {})
            if (res) {
                this.form = res;
                if(this.form.unit_arr.length != 0){
                    this.unitArr = true
                    this.domains = this.form.unit_arr[0]
                }
                else if(this.form.unit_arr.length == 0){
                    this.unitArr = false
                }
                this.form.file_list = this.form.file;

                this.images = this.form.image;
                
                // this.produceOptions.forEach((i) => {
                //    if(i.id != res.produce_vendor_id){
                //         this.form.produce_vendor_id = ''
                //    }
                // })

                // this.saleOptions.forEach((j) => {
                //    if(j.id != res.sale_vendor_id){
                //         this.form.sale_vendor_id = ''
                //    }
                // })

                // this.sorts.forEach((i) => {
                //    if(i.id != res.instrument_type){
                //         this.form.instrument_type = ''
                //    }
                // })

                if(res.produce_vendor_id == 0){
                    this.form.produce_vendor_id = ''
                }
                if(res.sale_vendor_id == 0){
                    this.form.sale_vendor_id = ''
                }
                if(res.instrument_type == 0){
                    this.form.instrument_type = ''
                }
                if(res.alert_number == 0){
                    this.form.alert_number = ''
                }
                if(res.cost == 0){
                    this.form.cost = ''
                }
            }
        },
        //查询厂家
        searchVendors(name){
            const url = vendorOptions
            const query = {
                name: name,
                type: 4,
            }
            this.$request('get', url, query).then(res => {
                this.produceOptions = res
            })
        },
        searchSale(name){
            const url = vendorOptions
            const query = {
                name: name,
                type: 6,
            }
            this.$request('get', url, query).then(res => {
                this.saleOptions = res
            })
        },
        //查询耗材类型
        searchTypeOption(){
            return this.$utils.getDict([306,322]).then((typeOptions) => {
                if(typeOptions){
                    this.sorts = typeOptions[306];
                    this.fileTypes = typeOptions[322]
                }
            })
        },
        //保存耗材数据
        submitDisposables(){
            this.$refs["form"].validate(valid => {
            if (valid) {
                this.buttonLoading = true;
                if (this.form.id != null) {
                    const url = disposablesEdit.replace('{id}', this.pageId)
                    
                    this.form.image = this.images.map(i => i.id)
                    this.form.file = this.form.file_list.map(i => i.id)

                    this.form.unit_arr = this.domains
                    
                    this.$request('post', url, this.form).then(res => {
                    if(res != null){
                      // 修改成功
                        this.$message.success(`修改成功`);
                        // this.$router.push(`/basic/disposables/index`)
                    }
                }).finally(() => {
                    this.buttonLoading = false;
                });
                }else {
                const urlCrtate = disposablesList
                
                this.form.image = this.images.map(i => i.id)
                this.form.file = this.form.file_list.map(i => i.id)
                
                this.form.unit_arr = this.domains

                this.$request('post', urlCrtate, this.form).then(res => {
                    if(res){
                      // 新增成功
                        this.$message.success(`新增成功`);
                        // this.$router.push(`/basic/disposables/index`)
                    }
                }).finally(() => {
                    this.buttonLoading = false;
                });
                }
            }
            });
        },

        getAvatar(imgs) {
            for (let i = 0; i < imgs.length; i++) {
                const item = {id:imgs[i].fileId,url:imgs[i].fileUrl}
                this.images = this.images.concat(item);
            }
        },
        deleteimg(id) {
            this.images.forEach((i, d) => {
                if (i.id === id) {
                this.images.splice(d, 1)
                }
            })
        },
        deleteFile(index) {
            this.form.file_list.splice(index, 1)
        },
        getFile(file) {
            // 接收文件
            const files = this.form.file_list || []
            files.push({
                id: file.fileId,
                url: file.fileUrl,
                name: file.name,
                type: file.type
            })
            this.$set(this.form, 'file_list', files)
        },
        openUpload(type) {
            if (type === 'picture') {
                this.$refs.pictureSelect.show()
            } else if (type === 'file') {
                this.$refs.uploadFile.show(this.fileTypes)
            }
        },
        //取消按钮
        back() {
            window.close()
        },
        view(src) {
            // 预览图片
            window.open(src, '_blank')
        },
        uploadAvatar() {
            // 上传器械图片
            this.$refs.pictureSelect.show()
        },
        uploadFile() {
            // 上传证书
            this.$refs.uploadFile.show()
        },
        addunitAll(){
            if(this.form.unit == ''){
              // 请填写基本单位
                this.$message.warning(`请填写基本单位`);
            }else{
                this.unitArr = true
                this.domains.push({
                    unit: null,
                    number: null,
                    key: Date.now()
                });
                this.domains[0].unit = this.form.unit
            }
        },
        deleteunitAll(){
            this.unitArr = false
            this.domains = []
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        removeDomain(item) {
            var index = this.domains.indexOf(item)
            if (index !== -1) {
                this.domains.splice(index, 1)
            }
        },
        addDomain() {
            this.domains.push({
                unit: null,
                number: null,
                key: Date.now()
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.disposables_edit{
    h3{
        color: #767676;
    }
    .disposables_center{
        background-color: white;
        border-radius: 10px;
        padding: 10px;
    }
    .divBorder{
        border: 2px solid #f9f9f9;
        border-radius: 10px;
        padding-top: 15px;
    }
    .upload-photo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        li {
            height: 170px;
            position: relative;
            list-style-type:none;
            .delete-img {
                display: none;
            }
          &:hover {
                .delete-img {
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    left: 10px;
                    top: 100px;
                    background: rgba(59, 60, 61, 0.5);
                    z-index: 999;
                    cursor: pointer;
                    text-align: right;
                    i {
                        margin: 8px 10px 0 0;
                        display: block;
                        font-size: 24px;
                        color: white;
                    }
                }
            }
        }
    }
}
</style>